import AppLayout from "@/layouts/AppLayout.vue";
import MandateListView from "@/views/mandates/MandateListView.vue";
import CreateMandateView from "@/views/mandates/dam/CreateMandateView.vue";
import DetailMandateView from '@/views/mandates/DetailMandateView.vue';
import MandateService from '@/services/mandate/mandateService.ts';
import UpdateMandateView from "@/views/mandates/dam/UpdateMandateView.vue";
import { MandatePublicStatusEnum } from "@/enums/mandate_enum.ts";
import { useAuthStore } from '@/stores/authStore.ts';
import AploService from '@/services/aplo/aploService.ts';
import TradingMandateView from "@/views/mandates/TradingMandateView.vue";
import TradingMandateService from "@/services/mandate/tradingMandateService.ts";

import type { RouteLocationNormalized } from 'vue-router';
import type {
  MandateInvestmentLimit,
  MandateResponse
} from '@/types/services/mandate/mandate.type.ts';
import type { MandateTradingDataResponseApi } from "@/types/services/mandate/tradingMandate.type.ts";
import type { AploAsset } from "@/types/services/aplo/aplo.type.ts";

export default [
  {
    path: '/mandates',
    name: 'mandatesManagement',
    component: MandateListView,
    meta: {
      parent: 'mandates',
      related: 'mandatesManagement',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_MANDATE']
    }
  },
  {
    path: '/mandates/create',
    name: 'createMandate',
    component: CreateMandateView,
    meta: {
      parent: 'mandates',
      related: 'mandatesManagement',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['ADD_MANDATE']
    },
    async beforeEnter(to: RouteLocationNormalized) {
      try {
        to.meta.assets = await AploService.getAssets()
        to.meta.investmentLimit = await MandateService.getMandateInvestmentLimit()
      } catch (_) {
        return { path: '/mandates' }
      }
    }
  },
  {
    path: '/mandates/:id',
    name: 'updateMandate',
    component: UpdateMandateView,
    meta: {
      parent: 'mandates',
      related: 'mandatesManagement',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['EDIT_MANDATE']
    },
    async beforeEnter(to: RouteLocationNormalized) {
      try {
        const mandate: MandateResponse = await MandateService.getMandate(Number(to.params.id))
        if (mandate.publicStatus == MandatePublicStatusEnum.CLOSED) {
          return { path: '/mandates' }
        }
        const assets: AploAsset[] = await AploService.getAssets();
        const investmentLimit: MandateInvestmentLimit = await MandateService.getMandateInvestmentLimit();
        to.meta.mandate = mandate
        to.meta.assets = assets
        to.meta.investmentLimit = investmentLimit
      } catch (_) {
        return { path: '/mandates' }
      }
    }
  },
  {
    path: '/mandates/:id/detail',
    name: 'detailMandate',
    component: DetailMandateView,
    meta: {
      parent: 'mandates',
      related: 'mandatesManagement',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['GET_MANDATE']
    },
    async beforeEnter(to: RouteLocationNormalized) {
      try {
        to.meta.mandate = await MandateService.getMandate(Number(to.params.id))
        const authStore = useAuthStore();
        if (!authStore.isAdmin) {
          to.meta.investment = await MandateService.getMandateInvestment(Number(to.params.id), 10, 1)
        }
      } catch (_) {
        return { path: '/mandates' }
      }
    }
  },
  {
    path: '/mandates/:id/trading',
    name: 'tradingMandate',
    component: TradingMandateView,
    meta: {
      parent: 'mandates',
      related: 'mandatesManagement',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['TRADE_MANDATE']
    },
    async beforeEnter(to: RouteLocationNormalized) {
      try {
        const tradingData: MandateTradingDataResponseApi = await TradingMandateService.getMandateTradingData(
          Number(to.params.id)
        )

        if (tradingData.publicStatus == MandatePublicStatusEnum.CLOSED) {
          return { path: '/mandates' }
        }

        to.meta.tradingData = tradingData
        to.meta.mandateId = Number(to.params.id)
      } catch (_) {
        return { path: '/mandates' }
      }
    }
  },
];
